var _rect, _g, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlockContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_858",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 0,
    width: 18,
    height: 8
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.57153,
    width: 17.1429,
    height: 7.71429,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2858 7.71559H-0.857073C-1.0844 7.71559 -1.30242 7.80589 -1.46317 7.96661C-1.62391 8.12734 -1.71422 8.34533 -1.71422 8.57263V17.143C-1.71422 17.3703 -1.62391 17.5883 -1.46317 17.749C-1.30242 17.9097 -1.0844 18 -0.857073 18H12.8572C13.0845 18 13.3026 17.9097 13.4633 17.749C13.6241 17.5883 13.7144 17.3703 13.7144 17.143V8.57263C13.7144 8.34533 13.6241 8.12734 13.4633 7.96661C13.3026 7.80589 13.0845 7.71559 12.8572 7.71559H12.0001V6.85856C12.0006 5.50676 11.5444 4.19442 10.7056 3.13426C9.86681 2.0741 8.69449 1.32827 7.3787 1.01766C6.0629 0.70706 4.68075 0.849888 3.4563 1.423C2.23185 1.99611 1.23687 2.9659 0.632643 4.17518L2.16607 4.94137C2.59765 4.0775 3.30839 3.38469 4.18307 2.97529C5.05776 2.56588 6.0451 2.46388 6.98503 2.68581C7.92496 2.90774 8.76236 3.4406 9.36148 4.19799C9.96059 4.95538 10.2863 5.8929 10.2858 6.85856V7.71559ZM12.0001 9.42966V16.2859H7.05719e-05V9.42966H12.0001ZM7.71436 12.0008H4.28578V13.7148H7.71436V12.0008Z",
    fill: "#50B600"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_858",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 18,
    height: 11
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85718,
    y: 7.71428,
    width: 17.1429,
    height: 10.2857,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 7.71559H8.57139C8.34406 7.71559 8.12605 7.80589 7.9653 7.96661C7.80456 8.12734 7.71425 8.34533 7.71425 8.57263V17.143C7.71425 17.3703 7.80456 17.5883 7.9653 17.749C8.12605 17.9097 8.34406 18 8.57139 18H22.2857C22.513 18 22.731 17.9097 22.8918 17.749C23.0525 17.5883 23.1428 17.3703 23.1428 17.143V8.57263C23.1428 8.34533 23.0525 8.12734 22.8918 7.96661C22.731 7.80589 22.513 7.71559 22.2857 7.71559H21.4285V6.85856C21.429 5.50676 20.9729 4.19442 20.1341 3.13426C19.2953 2.0741 18.123 1.32827 16.8072 1.01766C15.4914 0.70706 14.1092 0.849888 12.8848 1.423C11.6603 1.99611 10.6653 2.9659 10.0611 4.17518L11.5945 4.94137C12.0261 4.0775 12.7369 3.38469 13.6115 2.97529C14.4862 2.56588 15.4736 2.46388 16.4135 2.68581C17.3534 2.90774 18.1908 3.4406 18.7899 4.19799C19.3891 4.95538 19.7148 5.8929 19.7143 6.85856V7.71559ZM21.4285 9.42966V16.2859H9.42854V9.42966H21.4285ZM17.1428 12.0008H13.7143V13.7148H17.1428V12.0008Z",
    fill: "#50B600"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockContent);
export default __webpack_public_path__ + "static/media/unlock_content.3534f7e924bbf432a4dab056f0fa5aa2.svg";
export { ForwardRef as ReactComponent };